import "./../Style.css";
import React, { useEffect, useRef } from "react";
import { useSpring, animated } from "@react-spring/web";
import { i18n } from "../i18n";
import { useUserSettings } from "../user";
import Phone from "@mui/icons-material/Phone";
import EmailOutlinedIcon from "@mui/icons-material/EmailOutlined";
import PlaceOutlinedIcon from "@mui/icons-material/PlaceOutlined";
import beach from "./../pics/beach.jpg";
import sunset from "./../pics/sunsett.jpg";
import { Link } from "react-router-dom";

export const ContactDesktop = () => {
  const [settings] = useUserSettings();
  const { language } = settings;

  const Mailto = ({ email, subject = "", body = "", children }) => {
    let params = subject || body ? "?" : "";
    if (subject) params += `subject=${encodeURIComponent(subject)}`;
    if (body) params += `${subject ? "&" : ""}body=${encodeURIComponent(body)}`;

    return <a href={`mailto:${email}${params}`}>{children}</a>;
  };

  const refImg = useRef();
  const refText1 = useRef();
  const refText2 = useRef();
  const refText3 = useRef();

  const [imgSprings, imgApi] = useSpring(() => ({
    opacity: 0,
  }));

  const [textSprings1, textApi1] = useSpring(() => ({
    opacity: 0,
  }));

  const [textSprings2, textApi2] = useSpring(() => ({
    opacity: 0,
    // transform: "translateX(100px)",
  }));
  const [textSprings3, textApi3] = useSpring(() => ({
    opacity: 0,
    // transform: "translateX(100px)",
  }));

  useEffect(() => {
    imgApi.start({
      opacity: 0.7,
      delay: 200,
      transform: "translateY(0)",
      config: {
        tension: 170,
        friction: 26,
        precision: 0.01,
        duration: 400,
      },
    });
    textApi1.start({
      opacity: 1,
      delay: 400,
      transform: "translateY(0)",
      config: {
        tension: 170,
        friction: 26,
        precision: 0.01,
        duration: 400,
      },
    });
    textApi2.start({
      opacity: 1,
      delay: 400,
      transform: "translateY(0)",
      config: {
        tension: 170,
        friction: 26,
        precision: 0.01,
        duration: 400,
      },
    });
    textApi3.start({
      opacity: 1,
      delay: 400,
      transform: "translateY(0)",
      config: {
        tension: 170,
        friction: 26,
        precision: 0.01,
        duration: 400,
      },
    });

    const handleScroll = () => {
      if (refText1.current) {
        const rectText1 = refText1.current.getBoundingClientRect();
        if (rectText1.top < window.innerHeight && rectText1.bottom > 0) {
        }
      }

      if (refText2.current) {
        const rectText2 = refText2.current.getBoundingClientRect();
        if (rectText2.top < window.innerHeight && rectText2.bottom > 0) {
          textApi2.start({
            opacity: 1,
            delay: 200,
            transform: "translateY(0)",
            config: {
              tension: 170,
              friction: 26,
              precision: 0.01,
              duration: 800,
            },
          });
        }
      }
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, [textApi1, textApi2, textApi3, imgApi]);

  return (
    <div className="white">
      <animated.img
        ref={refImg}
        style={{
          ...imgSprings,
        }}
        src={beach}
        alt=""
        className="contact_pic"
      ></animated.img>
      <div className="row">
        <div className="times_text_cont">
          <animated.div
            ref={refText1}
            style={{
              ...textSprings1,
            }}
            className="times_text"
          >
            <p className="times_title">
              {i18n({ index: "contact", language })}
            </p>
            {/* <p className="times_subtitle">Por consultas en general.</p> */}
            <div className="contact_row">
              <PlaceOutlinedIcon
                style={{
                  color: "#53ddf9",
                  fontSize: "37px",
                  paddingRight: "15px",
                }}
              />
              <text className="times_subtext">
                Rambla Claudio Williman Parada 7, Playa Mansa, Punta del Este
              </text>
            </div>

            {/* <div className="contact_row"> */}
            <a
              className="contact_row"
              href="https://wa.me/59892291919"
              target="_blank"
              rel="noopener noreferrer"
            >
              <Phone
                style={{
                  color: "#53ddf9",
                  fontSize: "37px",
                  paddingRight: "15px",
                }}
              />
              <text className="times_subtext">(+598) 92 291 919</text>
            </a>
            {/* </div> */}

            <div className="contact_row">
              <Mailto email="imarangatumarketing@gmail.com" subject="" body="">
                <EmailOutlinedIcon
                  style={{
                    color: "#53ddf9",
                    fontSize: "37px",
                    paddingRight: "15px",
                  }}
                />
                <button
                  style={{
                    textDecoration: "none",
                    border: "none",
                    background: "none",
                    color: "#fff",
                  }}
                  className="times_subtext"
                >
                  imarangatumarketing@gmail.com
                </button>
              </Mailto>
            </div>
          </animated.div>
        </div>

        <div className="times_text_cont">
          <animated.div
            ref={refText2}
            style={{
              ...textSprings2,
            }}
            className="times_text"
          >
            <p className="times_title">{i18n({ index: "events", language })}</p>
            {/* <p className="times_subtitle">Por consultas en general.</p> */}
            <div className="contact_row">
              <PlaceOutlinedIcon
                style={{
                  color: "#53ddf9",
                  fontSize: "38px",
                  paddingRight: "15px",
                }}
              />
              <text className="times_subtext">
                Rambla Claudio Williman Parada 7, Playa Mansa, Punta del Este
              </text>
            </div>

            <a
              className="contact_row"
              href="https://wa.me/59892559595"
              target="_blank"
              rel="noopener noreferrer"
            >
              <Phone
                style={{
                  color: "#53ddf9",
                  fontSize: "38px",
                  paddingRight: "15px",
                }}
              />
              <text className="times_subtext">(+598) 92 559 595</text>
            </a>

            <div className="contact_row">
              <Mailto
                email="eventosimarangatu@gmail.com"
                subject="Evento"
                body=""
              >
                <EmailOutlinedIcon
                  style={{
                    color: "#53ddf9",
                    fontSize: "38px",
                    paddingRight: "15px",
                  }}
                />
                <button
                  style={{
                    textDecoration: "none",
                    border: "none",
                    background: "none",
                    color: "#53ddf9",
                  }}
                  className="times_subtext"
                >
                  {i18n({ index: "events_large", language })}
                </button>
                <button
                  style={{
                    textDecoration: "none",
                    border: "none",
                    background: "none",
                    color: "#fff",
                  }}
                  className="times_subtext"
                >
                  eventosimarangatu@gmail.com
                </button>
              </Mailto>
            </div>
            <div className="contact_row">
              <Mailto
                email="eventos@imarangatu.com.uy"
                subject="Evento"
                body=""
              >
                <EmailOutlinedIcon
                  style={{
                    color: "#53ddf9",
                    fontSize: "38px",
                    paddingRight: "15px",
                  }}
                />
                <button
                  style={{
                    textDecoration: "none",
                    border: "none",
                    background: "none",
                    color: "#53ddf9",
                  }}
                  className="times_subtext"
                >
                  {i18n({ index: "events_small", language })}
                </button>
                <button
                  style={{
                    textDecoration: "none",
                    border: "none",
                    background: "none",
                    color: "#fff",
                  }}
                  className="times_subtext"
                >
                  eventos@imarangatu.com.uy
                </button>
              </Mailto>
            </div>
          </animated.div>
        </div>

        {/* <div className="times_img_cont">
        <animated.img
          ref={refImg1}
          src={day}
          className="times_img"
          alt="1"
          style={imgSprings1}
        />
      </div> */}
        <div className="times_text_cont">
          <animated.div
            ref={refText3}
            style={{
              ...textSprings3,
            }}
            className="times_text"
          >
            <p className="times_title">
              {i18n({ index: "trabaja", language })}
            </p>

            <div className="contact_row">
              <Mailto
                email="imarangaturecursoshumanos@gmail.com"
                subject="Evento"
                body=""
              >
                <EmailOutlinedIcon
                  style={{
                    color: "#53ddf9",
                    fontSize: "38px",
                    paddingRight: "15px",
                  }}
                />
                <button
                  style={{
                    textDecoration: "none",
                    border: "none",
                    background: "none",
                    color: "#fff",
                  }}
                  className="times_subtext"
                >
                  imarangaturecursoshumanos@gmail.com
                </button>
              </Mailto>
            </div>
          </animated.div>
        </div>
      </div>
    </div>
  );
};

export const HomeReservation = () => {
  const [settings] = useUserSettings();
  const { language } = settings;

  const refText1 = useRef();
  const refText2 = useRef();

  const [textSprings1, textApi1] = useSpring(() => ({
    opacity: 0,
  }));
  const [textSprings2, textApi2] = useSpring(() => ({
    opacity: 0,
  }));

  useEffect(() => {
    const handleScroll = () => {
      if (refText1.current) {
        const rectText1 = refText1.current.getBoundingClientRect();
        if (rectText1.top < window.innerHeight && rectText1.bottom > 0) {
          textApi1.start({
            opacity: 1,
            delay: 200,
            transform: "translateY(0)",
            config: {
              tension: 170,
              friction: 26,
              precision: 0.01,
              duration: 400,
            },
          });
        }
      }

      if (refText2.current) {
        const rectText2 = refText1.current.getBoundingClientRect();
        if (rectText2.top < window.innerHeight && rectText2.bottom > 0) {
          textApi2.start({
            opacity: 1,
            delay: 200,
            transform: "translateY(0)",
            config: {
              tension: 170,
              friction: 26,
              precision: 0.01,
              duration: 400,
            },
          });
        }
      }
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, [textApi1, textApi2]);

  return (
    <div className="homerediv">
      <animated.div
        ref={refText1}
        style={{
          ...textSprings1,
        }}
        className="center_text"
      >
        <div className="reserve_title">
          <h2 className="title_title">{i18n({ index: "home1", language })}</h2>
        </div>
      </animated.div>
      <animated.div
        ref={refText2}
        style={{
          ...textSprings2,
        }}
        className="center_text"
      >
        <button className="reserve_button">
          <a className="href" href="https://imarangatu.meitre.com/">
            {i18n({ index: "home2", language })}
          </a>
        </button>
        <p className="green_subtext">{i18n({ index: "home3", language })}</p>
      </animated.div>
    </div>
  );
};

export const HomeMenu = () => {
  const [settings] = useUserSettings();
  const { language } = settings;

  const refText1 = useRef();
  const refText2 = useRef();

  const [textSprings1, textApi1] = useSpring(() => ({
    opacity: 0,
  }));
  const [textSprings2, textApi2] = useSpring(() => ({
    opacity: 0,
  }));

  useEffect(() => {
    const handleScroll = () => {
      if (refText1.current) {
        const rectText1 = refText1.current.getBoundingClientRect();
        if (rectText1.top < window.innerHeight && rectText1.bottom > 0) {
          textApi1.start({
            opacity: 1,
            delay: 200,
            transform: "translateY(0)",
            config: {
              tension: 170,
              friction: 26,
              precision: 0.01,
              duration: 400,
            },
          });
        }
      }

      if (refText2.current) {
        const rectText2 = refText1.current.getBoundingClientRect();
        if (rectText2.top < window.innerHeight && rectText2.bottom > 0) {
          textApi2.start({
            opacity: 1,
            delay: 200,
            transform: "translateY(0)",
            config: {
              tension: 170,
              friction: 26,
              precision: 0.01,
              duration: 400,
            },
          });
        }
      }
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, [textApi1, textApi2]);

  return (
    <div className="homerediv">
      <animated.div
        ref={refText1}
        style={{
          ...textSprings1,
        }}
        className="center_text"
      >
        <div className="reserve_title">
          <h2 className="title_title">BEACH CLUB, RESTAURANT & BAR</h2>
        </div>
      </animated.div>
      <animated.div
        ref={refText2}
        style={{
          ...textSprings2,
        }}
        className="center_text"
      >
        {/* <button className="reserve_button"> */}
        <Link className="reserve_button" to={"/menu"}>
          <text className="href">Menu</text>
        </Link>
        {/* </button> */}
        <p className="green_subtext">{i18n({ index: "home4", language })}</p>
      </animated.div>
    </div>
  );
};

export const HomeMenuIntro = () => {
  const [settings] = useUserSettings();
  const { language } = settings;

  const fadeIn = useSpring({
    from: { opacity: 0, transform: "translateY(20px)" },
    to: { opacity: 0.9, transform: "translateY(0px)" },
    config: { duration: 1000 },
  });

  return (
    <div className="homerediv">
      <animated.div style={fadeIn} className="menu_text">
        {/* <div className="reserve_title"> */}
        <p className="larger_text">{i18n({ index: "menu_intro", language })}</p>
        <p className="larger_text">{i18n({ index: "mati", language })}</p>
        {/* </div> */}
      </animated.div>
    </div>
  );
};

export const HomeSustainable = () => {
  const [settings] = useUserSettings();
  const { language } = settings;

  const refText1 = useRef();
  const refText2 = useRef();

  const [textSprings1, textApi1] = useSpring(() => ({
    opacity: 0,
  }));
  const [textSprings2, textApi2] = useSpring(() => ({
    opacity: 0,
  }));

  useEffect(() => {
    const handleScroll = () => {
      if (refText1.current) {
        const rectText1 = refText1.current.getBoundingClientRect();
        if (rectText1.top < window.innerHeight && rectText1.bottom > 0) {
          textApi1.start({
            opacity: 0.9,
            delay: 200,
            transform: "translateY(0)",
            config: {
              tension: 170,
              friction: 26,
              precision: 0.01,
              duration: 400,
            },
          });
          textApi2.start({
            opacity: 1,
            delay: 400,
            transform: "translateY(0)",
            config: {
              tension: 170,
              friction: 26,
              precision: 0.01,
              duration: 400,
            },
          });
        }
      }
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, [textApi1, textApi2]);

  return (
    <div className="homerediv">
      <animated.img
        ref={refText1}
        style={{
          ...textSprings1,
        }}
        src={beach}
        alt=""
        className="beach_pic"
      ></animated.img>
      <animated.div
        ref={refText2}
        style={{
          ...textSprings2,
        }}
        className="beacht"
      >
        <h6 className="beach_title">{i18n({ index: "sus1", language })}</h6>
        <p className="beach_text">{i18n({ index: "sus2", language })}</p>
        <p className="beach_text">{i18n({ index: "sus3", language })}</p>
        <p className="beach_text">{i18n({ index: "sus4", language })}</p>
        <p className="beach_text">{i18n({ index: "sus5", language })}</p>
        <p className="beach_text">{i18n({ index: "sus7", language })}</p>
        <p className="beach_text">{i18n({ index: "sus8", language })}</p>
        <a href="https://youtu.be/GV47LASEd5U" className="beach_text">
          Video
        </a>
        <p className="beach_text">{i18n({ index: "sus6", language })}</p>
      </animated.div>
    </div>
  );
};

export const HomeAbout = () => {
  const [settings] = useUserSettings();
  const { language } = settings;

  const refText1 = useRef();
  const refText2 = useRef();

  const [textSprings1, textApi1] = useSpring(() => ({
    opacity: 0,
  }));
  const [textSprings2, textApi2] = useSpring(() => ({
    opacity: 0,
  }));

  useEffect(() => {
    const handleScroll = () => {
      if (refText1.current) {
        const rectText1 = refText1.current.getBoundingClientRect();
        if (rectText1.top < window.innerHeight && rectText1.bottom > 0) {
          textApi1.start({
            opacity: 0.9,
            delay: 200,
            transform: "translateY(0)",
            config: {
              tension: 170,
              friction: 26,
              precision: 0.01,
              duration: 400,
            },
          });
          textApi2.start({
            opacity: 1,
            delay: 400,
            transform: "translateY(0)",
            config: {
              tension: 170,
              friction: 26,
              precision: 0.01,
              duration: 400,
            },
          });
        }
      }
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, [textApi1, textApi2]);

  return (
    <div className="homeredivblue">
      <animated.img
        ref={refText1}
        style={{
          ...textSprings1,
        }}
        src={sunset}
        alt=""
        className="sun_pic"
      ></animated.img>
      <animated.div
        ref={refText2}
        style={{
          ...textSprings2,
        }}
        className="sunt"
      >
        <h6 className="sun_title">I'MARANGATÚ</h6>
        <p className="sun_text">
          {i18n({ index: "poem1", language })}
          <br />
          {i18n({ index: "poem2", language })}
          <br />
          {i18n({ index: "poem3", language })}
          <br />
        </p>
        <p className="sun_text">
          {i18n({ index: "poem4", language })}
          <br />
          {i18n({ index: "poem5", language })}
          <br />
          {i18n({ index: "poem6", language })}
          <br />
          {i18n({ index: "poem7", language })} <br />
          {i18n({ index: "poem8", language })}
          <br />
          {i18n({ index: "poem9", language })}
        </p>
        <p className="sun_text">
          {i18n({ index: "poem10", language })}
          <br />
          {i18n({ index: "poem11", language })}
          <br />
          {i18n({ index: "poem12", language })}
        </p>
      </animated.div>
    </div>
  );
};
